import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from './useAuth';
import { fetchDriverReminderInbox } from '../utils/reminderInbox';

/** Unread driver in-app reminder count; refreshes on route change. */
export function useDriverReminderUnread(): number {
  const { driverId } = useAuth();
  const location = useLocation();
  const [count, setCount] = useState(0);

  const reload = useCallback(async () => {
    if (!driverId) {
      setCount(0);
      return;
    }
    try {
      const { unreadIds } = await fetchDriverReminderInbox(driverId);
      setCount(unreadIds.length);
    } catch {
      // keep last known count
    }
  }, [driverId]);

  useEffect(() => {
    void reload();
  }, [reload, location.pathname]);

  useEffect(() => {
    if (!driverId) return;
    const id = window.setInterval(() => {
      void reload();
    }, 60_000);
    return () => window.clearInterval(id);
  }, [driverId, reload]);

  return count;
}
